
import  DaneServices  from '../api/Dane/api-dane'

export const useRegitrarUsuarioUME = () => {

    const guardarUsuario = async(usuarioRegitrar: any) => {
        //console.log(usuarioRegitrar)
        const response = await  DaneServices.guardarUsuario(usuarioRegitrar)
        //console.log(response)
        return response;
    }

    const cambiarContraseniaUsuario = async (doc_number: string, password: string, new_password: string) => {


        let cambiarContraseñia = {
            doc_number,
            password,
            new_password
        }

        const response = await  DaneServices.cambiarContraseniaUsuario(cambiarContraseñia)
        return response;


    }

    const recuperarContrasenia = async (documento: string, correo: string, ) => {

        let data = {
            documento,
            correo
        }

        const response = await  DaneServices.recuperarContrasenia(data)
        return response;

    }


    const iniciarSesion = (usuario: string, contra: string) => {
        // const autenticacion = generarAutentificacion();

        let data = {
            info:{
                action:"inicioSesion",
                usuario,
                contra,
            },
            // autenticacion
        }

        // const response = await  DaneServices.cambiarContraseniaUsuario(data)
        // return response;
    }

    const obtenerUsuario = (identificacion: number) => {
        // const autenticacion = generarAutentificacion();

        let data = {
            info:{
                action:"consultarPersona",
                usuario: identificacion,
            },
            // autenticacion
        }

        // const response = await  DaneServices.obtenerUsuario(data)
        // return response;

    }




    return {
        guardarUsuario,
        cambiarContraseniaUsuario,
        iniciarSesion,
        recuperarContrasenia
    }





}
